import urlResolver from 'admin/utils/URLResolver';
import useSWRImmutable from 'swr/immutable';

export const useClassAssemblage = (classId) => {
  const { data: assemblage, error } = useSWRImmutable(
    urlResolver.reverse('api:course-assemblage', { classId })
  );

  if (error) {
    console.error('There was an error loading the course assemblage', error);
  }

  return {
    data: assemblage,
    error,
    loading: !assemblage && !error,
  };
};
